<main>
  <ul class="call-history-head">
    <li class="title">
      <i
        class="icon-small-back pull-left"
        routerLink="../options"></i>
      {{ "global-call-history.title" | Translate }}
    </li>
    <li class="call-history-head_action">
      <button
        class="vox-btn"
        (click)="openFilterPopup()">
        <span class="call-history-head_action-counter">{{ appliedFiltersNumber }}</span>
        <i class="icon-small-preferences"></i>
      </button>
      <button
        class="vox-btn"
        (click)="refreshTable()">
        <i class="icon-small-update"></i>
      </button>
    </li>
  </ul>

  <div
    id="content"
    class="call-history-main">
    <div class="call-history-main__table">
      <app-call-log-table
        (onOpeningDetails)="openDetails($event)"
        [callLog]="callLog"
        [loading]="loading"
        [loadingRows]="pageSize || 20"></app-call-log-table>
    </div>
    <div class="call-history-main__pagination">
      <app-pagination
        (onSelectPageSize)="selectPageSize($event)"
        (onChangeCurrentPage)="changeCurrentPage($event)"
        [totalPages]="pagination.totalPages"
        [pagination]="pagination"></app-pagination>
    </div>
  </div>
  <app-call-log-details
    [aiAssistant]="aiAssistant"
    [subscription]="subscription"
    [callItem]="selectedRecord"
    [open]="showDetails"
    (closing)="closeDeatils()"></app-call-log-details>
  <app-call-history-filter-popup
    (filtersChanged)="onFiltersChanged($event)"
    [hideOnInitPage]="hideFilterOnInitPage"
    [open]="showFilter"
    (closing)="showFilter = false"></app-call-history-filter-popup>
</main>
